import React, { useState } from 'react'
import { Menu, MenuButton, MenuItems, Transition } from '@headlessui/react'
import { ArrowsRightLeftIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function MoveInvoicesDropdown({ availableFunds, actionUrl, csrfToken }) {
  const [selectedFundId, setSelectedFundId] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!selectedFundId) {
      alert('Please select a destination fund')
      return
    }

    const confirmMessage = 'Are you sure you want to move these invoices? This action cannot be undone.'
    if (!confirm(confirmMessage)) {
      return
    }

    // Create form data
    const formData = new FormData()
    formData.append('to_fund_id', selectedFundId)
    formData.append('status', selectedStatus)
    formData.append('authenticity_token', csrfToken)

    // Submit the form
    fetch(actionUrl, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        alert('Error moving invoices. Please try again.')
      }
    }).catch(error => {
      console.error('Error:', error)
      alert('Error moving invoices. Please try again.')
    })
  }

  if (!availableFunds || availableFunds.length === 0) {
    return null
  }

  return (
    <Menu as="div" className="ml-3 relative inline-block text-left">
      <div>
        <MenuButton className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          <ArrowsRightLeftIcon className="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
          Move Invoices
          <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
        </MenuButton>
      </div>

      <Transition
        as="div"
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 z-10 mt-2 w-80 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1 p-4">
            <h3 className="text-sm font-medium text-gray-900 mb-3">Move Invoices to Another Fund</h3>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label htmlFor="to_fund_id" className="block text-sm font-medium text-gray-700">
                  Destination Fund
                </label>
                <select
                  id="to_fund_id"
                  value={selectedFundId}
                  onChange={(e) => setSelectedFundId(e.target.value)}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  required
                >
                  <option value="">Select a fund...</option>
                  {availableFunds.map((fund) => (
                    <option key={fund.id} value={fund.id}>
                      {fund.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor="status" className="block text-sm font-medium text-gray-700">
                  Invoice Status (optional)
                </label>
                <select
                  id="status"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                >
                  <option value="">All invoices</option>
                  <option value="unpaid">Unpaid only</option>
                  <option value="paid">Paid only</option>
                  <option value="failed">Failed only</option>
                  <option value="partial_payment">Partial payment only</option>
                  <option value="overdue">Overdue only</option>
                </select>
              </div>

              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={() => {
                    // Close the menu by triggering a click outside
                    document.body.click()
                  }}
                  className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Move Invoices
                </button>
              </div>
            </form>
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  )
}